// extracted by mini-css-extract-plugin
module.exports = {"chart":"area-rank_chart_2f6GL","canvas":"area-rank_canvas_2zgja"};